import { Events, dispatch } from "../redux/dispatch";

export const useAppControl = () => {
  const showLoading = async () => dispatch(Events.SET_IS_LOADING, true);

  const hideLoading = async () => dispatch(Events.SET_IS_LOADING, false);

  return { showLoading, hideLoading };
};
